<template>
  <div class="RegisterView">
    <h1>REGISTER</h1>
  </div>
</template>